export * from './tiptap-table-of-contents.component';
